import { useFormContext, Controller } from "react-hook-form";
import PropTypes from "prop-types";
import EINInput from "./FormInputs/EINInput";
import { validateEIN } from "../ValidateFunctions"

FormEinField.propTypes = {
  fieldName: PropTypes.string,
  focusedField: PropTypes.string,
  setFocusedField: PropTypes.func,
  fieldAttributes: PropTypes.object,
}

export default function FormEinField({ fieldName, focusedField, setFocusedField, fieldAttributes }) {
  const { control } = useFormContext();

  return <Controller
      name={fieldName}
      control={control}
      rules={{
        validate: value => validateEIN(value)
      }}
      render={() => (
        <EINInput
          fieldName={fieldName}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
          fieldAttributes={fieldAttributes}
        />
      )}
    />
}